import { croAccountingConstants } from '../../_constants';
import { croAccountingServices } from '../../_services';
import { alertActions, userActions, } from '../index';
import { confirmPromptActions } from '../confirmPromptActions';

export const croAccountingdActions = {
    resetCroAccounting,

    // GET
    getVoyageListingForCroAccounting,
    getWayBIllListForCROAccounting,
    getWayBIllCROAccounting,
    getCroId,
    getVoyageDestination,

    // POST 
    createCroAccounting,
    generateWaybillInvoice,
    postCROAccounting,
    postCROToBase,

    // PUT
    updateCROAccounting,
    updateCROAccountingStatus,

    // DELETE
    deleteCroAccounting,

    // PDC CLearing
    loadPdcCollection,
    clearPdcCollection,

    // BASE Manual SI
    manualSalesInvoice,
    CRUDManualSI,
    manualSalesInvoiceOther,
}

function resetCroAccounting() { return { type: croAccountingConstants.RESET } }

function croAccountingFetching() { return { type: croAccountingConstants.CROACCOUNTING_FETCHING } }
function croAccountingFetched() { return { type: croAccountingConstants.CROACCOUNTING_FETCHED } }

function croAccountingSubmitting() { return { type: croAccountingConstants.CROACCOUNTING_SUBMITTING } }
function croAccountingSubmitted() { return { type: croAccountingConstants.CROACCOUNTING_SUBMITTED } }

function getVoyageListingForCroAccounting(search) {
    return dispatch => {
        dispatch(croAccountingFetching());
        dispatch(userActions.allowLeavePage());
        croAccountingServices.getVoyageListingForCroAccounting(search)
            .then(
                voyageListCroAccounting => {
                    dispatch(croAccountingFetched());
                    dispatch(success(voyageListCroAccounting));
                },
                error => {
                    dispatch(croAccountingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(voyageListCroAccounting) { return { type: croAccountingConstants.GET_VOYAGE_LIST_CRO_ACCOUNTING, voyageListCroAccounting } }
}

function getWayBIllListForCROAccounting(voyageNum) {
    return dispatch => {
        dispatch(croAccountingFetching());
        dispatch(userActions.allowLeavePage());
        croAccountingServices.getWayBIllListForCROAccounting(voyageNum)
            .then(
                waybillListCroAccounting => {
                    if(!waybillListCroAccounting.message){
                        dispatch(croAccountingFetched());
                        dispatch(success(waybillListCroAccounting));
                    }
                    else{
                        dispatch(croAccountingFetched());
                        dispatch(alertActions.warning(waybillListCroAccounting.message))
                    }
                },
                error => {
                    dispatch(croAccountingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(waybillListCroAccounting) { return { type: croAccountingConstants.GET_WAYBILL_LIST_CRO_ACCOUNTING, waybillListCroAccounting } }
}

function getWayBIllCROAccounting(waybillRef) {
    return dispatch => {
        dispatch(croAccountingFetching());
        dispatch(userActions.allowLeavePage());
        croAccountingServices.getWayBIllCROAccounting(waybillRef)
            .then(
                waybillCroAccounting => {
                    dispatch(croAccountingFetched());
                    dispatch(success(waybillCroAccounting));
                },
                error => {
                    dispatch(croAccountingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(waybillCroAccounting) { return { type: croAccountingConstants.GET_WAYBILL_CRO_ACCOUNTING, waybillCroAccounting } }
}

function getCroId(croId) {
    return dispatch => {
        dispatch(croAccountingFetching());
        dispatch(userActions.allowLeavePage());
        croAccountingServices.getCroId(croId)
            .then(
                CroById => {
                    dispatch(croAccountingFetched());
                    dispatch(success(CroById));
                },
                error => {
                    dispatch(croAccountingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(CroById) { return { type: croAccountingConstants.GET_CRO_ACCOUNTING_BY_ID, CroById } }
}

function createCroAccounting(payload) {
    return dispatch => {
        dispatch(croAccountingSubmitting());
        dispatch(userActions.notallowLeavePage());
        croAccountingServices.createCroAccounting(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(croAccountingSubmitted());
                    dispatch(alertActions.success(success.message));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(croAccountingSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}

function updateCROAccounting(payload, id) {
    return dispatch => {
        dispatch(croAccountingSubmitting());
        dispatch(userActions.notallowLeavePage());
        croAccountingServices.updateCROAccounting(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(croAccountingSubmitted());
                    dispatch(alertActions.success(success.message));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(croAccountingSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}

function updateCROAccountingStatus(payload, id) {
    return dispatch => {
        dispatch(croAccountingSubmitting());
        dispatch(userActions.notallowLeavePage());
        croAccountingServices.updateCROAccountingStatus(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(croAccountingSubmitted());
                    dispatch(alertActions.success(success.message));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(croAccountingSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}

function deleteCroAccounting(id) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        croAccountingServices.deleteCroAccounting(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success(success.message));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}

function getVoyageDestination(voyageNum) {
    return dispatch => {
        dispatch(croAccountingFetching());
        croAccountingServices.getVoyageDestination(voyageNum)
            .then(
                voyageDestination => {
                    if(!voyageDestination.message){
                        dispatch(croAccountingFetched());
                        dispatch(success(voyageDestination));
                    }
                    else{
                        dispatch(croAccountingFetched());
                        dispatch(alertActions.warning(voyageDestination.message))
                    }
                },
                error => {
                    dispatch(croAccountingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(voyageDestination) { return { type: croAccountingConstants.GET_VOYAGE_DESTINATION, voyageDestination } }
}

function generateWaybillInvoice(voyageNum, destination, branchCodeId) {
    return dispatch => {
        dispatch(croAccountingFetching());
        croAccountingServices.generateWaybillInvoice(voyageNum, destination, branchCodeId)
            .then(
                waybillInvoice => {
                    if(!waybillInvoice.message){
                        if(waybillInvoice && waybillInvoice.length > 0){
                            dispatch(croAccountingFetched());
                            dispatch(success(waybillInvoice));
                        }
                        else{
                            dispatch(croAccountingFetched());
                            dispatch(alertActions.warning('No more Waybill Data'))
                        }
                        // if(waybillInvoice.waybill && waybillInvoice.waybill.length > 0){
                        //     dispatch(croAccountingFetched());
                        //     dispatch(success(waybillInvoice));
                        // }
                        // else{
                        //     dispatch(croAccountingFetched());
                        //     dispatch(alertActions.warning('No more Waybill Data'))
                        // }
                    }
                    else{
                        dispatch(croAccountingFetched());
                        dispatch(alertActions.warning(waybillInvoice.message))
                    }
                },
                error => {
                    dispatch(croAccountingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(waybillInvoice) { return { type: croAccountingConstants.GENERATE_WAYBILL_INVOICE, waybillInvoice } }
}

function postCROAccounting(payload) {
    return dispatch => {
        dispatch(croAccountingFetching());
        dispatch(croAccountingSubmitting());
        dispatch(userActions.notallowLeavePage());
        croAccountingServices.postCROAccounting(payload)
            .then(
                POSTCRO => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(croAccountingFetched());
                    dispatch(croAccountingSubmitted());
                    dispatch(alertActions.success(POSTCRO.message));
                    dispatch(success(POSTCRO));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(croAccountingFetched());
                    dispatch(croAccountingSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(POSTCRO) { return { type: croAccountingConstants.CRO_POST, POSTCRO } }
}

function postCROToBase(payload) {
    return dispatch => {
        dispatch(croAccountingFetching());
        dispatch(croAccountingSubmitting());
        dispatch(userActions.notallowLeavePage());
        croAccountingServices.postCROToBase(payload)
            .then(
                POSTCRO => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(croAccountingFetched());
                    dispatch(croAccountingSubmitted());
                    if(POSTCRO.custDetails && POSTCRO.custDetails.length > 0){
                        if(POSTCRO.message){ dispatch(alertActions.warning(POSTCRO.message));}
                        else if(POSTCRO.Message){ dispatch(alertActions.warning(POSTCRO.Message));}   
                    } else{
                        if(POSTCRO.message){ dispatch(alertActions.success(POSTCRO.message));}
                        else if(POSTCRO.Message){ dispatch(alertActions.success(POSTCRO.Message));}
                    }
                    dispatch(success(POSTCRO));
                    // dispatch(confirmPromptActions.hide());
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(croAccountingFetched());
                    dispatch(croAccountingSubmitted());
                    if(error.message){ dispatch(alertActions.error(error.message));}
                    else if(error.Message){ dispatch(alertActions.error(error.Message));}
                    else{ dispatch(alertActions.error(error))}
                    // dispatch(confirmPromptActions.hide());
                }
            )
    }
    function success(POSTCRO) { return { type: croAccountingConstants.CRO_POST, POSTCRO } }
}

function loadPdcCollection(load) {
    return dispatch => {
        dispatch(croAccountingFetching());
        dispatch(userActions.allowLeavePage());
        croAccountingServices.loadPdcCollection(load)
            .then(
                pdcCollection => {
                    dispatch(confirmPromptActions.hide());
                    dispatch(croAccountingFetched());
                    dispatch(success(pdcCollection));
                },
                error => {
                    dispatch(croAccountingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(pdcCollection) { return { type: croAccountingConstants.LOAD_PDC_COLLECTION, pdcCollection } }
}

function clearPdcCollection(payload, load) {
    return dispatch => {
        dispatch(croAccountingFetching());
        dispatch(userActions.notallowLeavePage());
        croAccountingServices.clearPdcCollection(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    console.log('success', success);
                    dispatch(confirmPromptActions.hide());
                    dispatch(croAccountingFetched());
                    dispatch(alertActions.success("Cleared Successfully"));
                    setTimeout(() => {
                        dispatch(loadPdcCollection(load));                        
                    }, 500);

                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(croAccountingFetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}

function manualSalesInvoice(payload) {
    return dispatch => {
        dispatch(croAccountingFetching());
        croAccountingServices.manualSalesInvoice(payload)
            .then(
                manualSI => {
                    let returnData = {
                        actionType: payload.actionType,
                        data: manualSI,
                    }
                    dispatch(success(returnData));
                    dispatch(croAccountingFetched());
                },
                error => {
                    dispatch(croAccountingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(manualSI) { return { type: croAccountingConstants.MANUAL_SALES_INVOICE, manualSI } }
}

function CRUDManualSI(payload, link) {
    return dispatch => {
        dispatch(croAccountingSubmitting());
        dispatch(userActions.notallowLeavePage());
        croAccountingServices.manualSalesInvoice(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());

                    if(payload.actionType === "deleteManualSalesInvoice"){
                        dispatch(alertActions.success("Manual SI Deleted Successfully"));
                    }
                    else if(payload.actionType === "updateManualSalesInvoice"){
                        dispatch(alertActions.success("Manual SI Updated Successfully"));
                    }
                    else if(payload.actionType === "createManualSalesInvoice"){
                        dispatch(alertActions.success("Manual SI Created Successfully"));
                    }

                    if(link === "delete"){
                        let load = {
                            actionType: "listManualSalesInvoice",
                            search: "",
                            skip: 0,
                            take: 20,
                        };
                        dispatch(manualSalesInvoice(load));
                    }
                    else {
                        window.location.href = link;
                    }
                 
                    dispatch(croAccountingSubmitted());
                    dispatch(confirmPromptActions.hide());
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    if(link === "delete"){
                        let load = {
                            actionType: "listManualSalesInvoice",
                            search: "",
                            skip: 0,
                            take: 20,
                        };
                        dispatch(manualSalesInvoice(load));
                    }
                    dispatch(croAccountingSubmitted());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(confirmPromptActions.hide());
                }
            )
    }
}

function manualSalesInvoiceOther(payload) {
    return dispatch => {
        dispatch(croAccountingFetching());
        croAccountingServices.manualSalesInvoice(payload)
            .then(
                manualSIOther => {
                    let returnData = {
                        actionType: payload.actionType,
                        data: manualSIOther,
                    }
                    dispatch(success(returnData));
                    dispatch(croAccountingFetched());
                },
                error => {
                    dispatch(croAccountingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(manualSIOther) { return { type: croAccountingConstants.MANUAL_SALES_INVOICE_OTHER, manualSIOther } }
}